/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes').controller('CopyMoveController', [
    '$scope',
    '$location',
    '$modalInstance',
    '$q',
    '$translate',
    'element',
    'selectionCountSummary',
    'operationComplete',
    'multiResultsArray',
    'multiResultsModal',
    'confirmAction',
    'SYNC_STATUS',
    function (
        $scope,
        $location,
        $modalInstance,
        $q,
        $translate,
        element,
        selectionCountSummary,
        operationComplete,
        multiResultsArray,
        multiResultsModal,
        confirmAction,
        SYNC_STATUS
    ) {
        var CONFLICT_ERROR_CODE = 409,
            ROOT_UUID = '0';

        $scope.modal = $modalInstance.options;
        $scope.elements = element.length > 1 ? element : [element];
        $scope.transfer = {
            destination: null,
            conflict: false
        };
        $scope.resource = 'sync_and_share_nodes';
        $scope.NOT_SYNCED = SYNC_STATUS.NOT_SYNCED;

        $scope.ok = function () {
            var isDirectory = $scope.elements[0].is_directory,
                multiResults = multiResultsArray($scope.elements, function (e) {
                    return e.constructor[$scope.modal.action]({
                        uuid: e.uuid,
                        parent_uuid: $scope.transfer.destination.uuid || ROOT_UUID,
                        conflict_override: $scope.transfer.conflict ? true : null
                    }).$promise;
                });

            $scope.modal.loading = true;

            _confirmMoveSyncedFolderToNonSynced($scope.elements, $scope.transfer.destination)
                .then(function () {
                    if ($scope.elements.length == 1) {
                        multiResults[0]
                            .promise()
                            .then(function () {
                                if ($scope.modal.action === 'copy') {
                                    operationComplete(isDirectory ? 'Folder copied.' : 'File copied.');
                                } else {
                                    operationComplete(isDirectory ? 'Folder transferred.' : 'File transferred.');
                                }
                                $modalInstance.close('reload_nodes');
                            })
                            .then(function () {
                                if ($scope.modal.action === 'move') {
                                    _redirectToDestination($scope.transfer.destination);
                                }
                            })
                            .catch(function (response) {
                                if (response.status && response.status == CONFLICT_ERROR_CODE) {
                                    $scope.transfer.conflict = true;
                                }
                                $scope.modal.loading = false;
                            });
                    } else {
                        multiResultsModal(
                            multiResults,
                            selectionCountSummary,
                            $scope.elements[0].constructor,
                            $scope.modal.action
                        )
                            .then(function () {
                                if ($scope.modal.action === 'move' && !_hasUnresolvedConflicts(multiResults)) {
                                    _redirectToDestination($scope.transfer.destination);
                                }
                            })
                            .finally(function () {
                                $modalInstance.close('reload_nodes');
                            });
                    }
                })
                .catch(function () {
                    // This catch means user doesn't confirm moving
                    // synced node(s) into unsynced folder
                    $scope.modal.loading = false;
                });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.close = function () {
            $modalInstance.close('reload_nodes');
        };

        $modalInstance.result.finally(function () {
            $scope.transfer.conflict = null;
        });

        function _isFolderSynced(node) {
            return node.is_directory && node.synced !== SYNC_STATUS.NOT_SYNCED;
        }

        function _confirmMoveSyncedFolderToNonSynced(nodes, target) {
            var syncedFolders = nodes.filter(_isFolderSynced);

            if (
                $scope.modal.action !== 'move' ||
                syncedFolders.length === 0 ||
                _isFolderSynced(angular.extend(target, { is_directory: true })) ||
                target.isRoot()
            ) {
                return $q.resolve();
            }

            var confirmTextsArray = [
                'moving_synced_folder_into_non_synced_folder_title',
                'moving_synced_folder_into_non_synced_folder_text',
                'Continue',
                'Cancel'
            ];

            return $q
                .all(
                    syncedFolders.map(function (folder) {
                        return $translate('moving_synced_folder_into_non_synced_folder_quoted', {
                            folder_name: folder.name
                        });
                    })
                )
                .then(function (folderNames) {
                    return $translate(
                        confirmTextsArray,
                        { COUNT: syncedFolders.length, folder_names: folderNames.join(', ') },
                        'messageformat'
                    );
                })
                .then(function (dictionary) {
                    return confirmAction(
                        {},
                        {
                            confirmTitle: dictionary[confirmTextsArray[0]],
                            confirmBody: dictionary[confirmTextsArray[1]],
                            confirmSubmit: dictionary[confirmTextsArray[2]],
                            confirmCancel: dictionary[confirmTextsArray[3]]
                        }
                    );
                });
        }

        function _hasUnresolvedConflicts(results) {
            for (var i = 0; i < results.length; i++) {
                if (angular.isDefined(results[i].conflictTransfer) && !angular.isDefined(results[i].conflictResolved)) {
                    return true;
                }
            }

            return false;
        }

        function _redirectToDestination(dest) {
            $location.url(dest.getUrl(true));
        }
    }
]);
